import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.data.community;

const getCommunity = createSelector(getData, community => values(community));

export default getCommunity;



// WEBPACK FOOTER //
// ./src/_selectors/dataSelectors/getCommunity.js